module.exports = __webpack_public_path__ + "img/frankliniella-occidentalis.3c82bbb4.jpg";